import {Mapper} from '@s-ui/domain'

export class FromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper extends Mapper {
  constructor({config, filteredProvincesValueObject}) {
    super()
    this._config = config
    this._filteredProvincesValueObject = filteredProvincesValueObject
  }

  map = ({userAlertsListValueObject, userAlertIdValueObject}) => {
    const filteredProvincesResults = this._config.get('filteredProvincesResults')

    const userAlerts = userAlertsListValueObject.getUserAlerts()
    const alertId = userAlertIdValueObject.getAlertId()
    const filteredAlert = userAlerts.find(alert => alert.getAlertId() === alertId)

    if (filteredAlert === undefined) return this._getValueObject(filteredProvincesResults.UNKNOWN)

    if (filteredAlert.getFilters().provinceIds.length === 0) return this._getValueObject(filteredProvincesResults.ALL)

    const provincesDictionary = this._config.get('provinces')
    const alertProvinces = filteredAlert.getFilters().provinceIds
    const filteredProvincesList = alertProvinces.map(alertProvince =>
      provincesDictionary.find(province => province.id === alertProvince).label.toLowerCase()
    )

    const filteredProvinces = filteredProvincesList.join(':')
    return this._getValueObject(filteredProvinces)
  }

  _getValueObject(filteredProvinces) {
    return this._filteredProvincesValueObject({filteredProvinces})
  }
}
